module.exports = __webpack_public_path__ + "html/project-summary_56c3c8fcec7c5d740ea47ca468d6b4b7.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-summary.html
// module id = O3cu
// module chunks = 51